import { isMobile } from 'react-device-detect';

import { PORTRAIT_PRIMARY, PORTRAIT_SECONDARY } from './constants';

export const getIsPortrait = () => {
  const orientation = screen.orientation?.angle ?? window.orientation;
  const isPortrait = [PORTRAIT_PRIMARY, PORTRAIT_SECONDARY].includes(orientation);

  return isMobile && isPortrait;
};
